import { BREAKPOINTS } from '../config.js';
import { lockScroll, unlockScroll } from '../utils/lockscroll.js';

const mq = window.matchMedia(`(max-width: ${BREAKPOINTS.mqTouch}px)`);

const header = document.querySelector('.header');
const burger = document.querySelector('.burger');

const mobMenu = document.querySelector('.mobmenu');
const mobMenuBody = document.querySelector('.mobmenu__body');
const mobNavLinks = document.querySelectorAll(
  '.mobmenu .navmenu__list a, .anchor'
);

let isMenuOpened = false;

function toggleMenu() {
  isMenuOpened = !isMenuOpened;
  header.classList.toggle('is-open');
  burger.classList.toggle('is-open');
  mobMenu.classList.toggle('is-open');

  if (isMenuOpened) {
    lockScroll(mobMenuBody);
  } else {
    unlockScroll();
  }
}

function closeMenu() {
  if (isMenuOpened) {
    isMenuOpened = false;
    header.classList.remove('is-open');
    burger.classList.remove('is-open');
    mobMenu.classList.remove('is-open');

    unlockScroll();
  }
}

function handleBreakpoint(e) {
  if (!e.matches) {
    closeMenu();
  }
}

function initMenu() {
  if (!burger || !mobMenu || !mobMenuBody) return;

  mq.addEventListener('change', handleBreakpoint);
  burger.addEventListener('click', toggleMenu);

  mobNavLinks.forEach(link => {
    link.addEventListener('click', event => {
      const itemChildren = event.target.closest('.menu-item');

      const hasItemChildren = itemChildren?.classList.contains(
        'menu-item-has-children'
      );

      if (!hasItemChildren) {
        closeMenu();
      }
    });
  });
}

function setViewportVars() {
  // розрахунок height: 100vh на iOS
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  // 2. hh — висота хедера
  if (header) {
    const hh = header.offsetHeight;
    document.documentElement.style.setProperty('--hh', `${hh}px`);
  }
}

window.addEventListener('resize', setViewportVars);
window.addEventListener('orientationchange', setViewportVars);
document.addEventListener('DOMContentLoaded', setViewportVars);

document.addEventListener('DOMContentLoaded', initMenu);
